module.exports = __webpack_public_path__ + "img/image99.208d6966.png";